var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { HDSButton } from "@here/hds-react-components/Button";
import { HDSLogo } from "@here/hds-react-components/Logo";
import { HDSIcon } from "@here/hds-react-components/Icon";
import { useSelector } from "react-redux";
import { ConfirmDailog } from "../../generic-components";
import "./header.scss";
var Header = function (_a) {
    var user = _a.user, env = _a.env, logOut = _a.logOut;
    var domain = useSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.app) === null || _a === void 0 ? void 0 : _a.environment) === null || _b === void 0 ? void 0 : _b.domain; });
    var PrettyPrintJson = function (_a) {
        var data = _a.data;
        return (_jsx("div", { children: _jsx("pre", { children: JSON.stringify(data, null, 2) }) }));
    };
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    return (_jsxs("header", __assign({ slot: "logo" }, { children: [_jsx("a", __assign({ className: "logo", href: "https://".concat(domain), rel: "noreferrer" }, { children: _jsx(HDSLogo, { id: "here-logo", color: "#383C45", "data-cy": "here-logo" }) })), isOpen && (_jsx(ConfirmDailog, __assign({ className: "flex", id: "modal-env", hideCloseBtn: true, onClose: function () { return setIsOpen(false); }, header: _jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: {
                                alignItems: "center",
                                display: "flex",
                                flexDirection: "column",
                                position: "absolute",
                                width: "100%",
                                margin: "-20px ",
                                fontSize: "15px",
                            } }, { children: [_jsxs("div", { children: ["User:", user.given_name] }), _jsxs("div", { children: ["Realm:", user.realm] })] })), _jsx(HDSIcon, { name: "cross", id: "cross-user-details", onClick: function () { return setIsOpen(false); }, style: { left: "27rem", position: "absolute", top: "1rem" } })] }), footer: _jsx(_Fragment, { children: _jsx("div", { children: _jsx(HDSButton, __assign({ width: "128px", onClick: logOut, size: "small", variant: "primary" }, { children: "Log Out" })) }) }) }, { children: _jsx(_Fragment, { children: _jsx("div", __assign({ lang: "javascript" }, { children: _jsx(PrettyPrintJson, { data: env }) })) }) })))] })));
};
export default Header;
